/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance,{ axiosInstance9000 } from "../api/axiosInstance";

export const fetchProfile = createAsyncThunk(
  "profileData/fetchProfile",
  async (_, { rejectWithValue }) => {
    try {
      const userRole = localStorage.getItem("userRole");
      let endpoint;
      if (userRole === "Head Office") {
        endpoint = "/api/headoffice/profile";
      } else if (userRole === "insured") {
        endpoint = "/api/insured/profile";
      } else if (userRole === "workshop") {
        endpoint = "/api/workshop/profile";
      } else {
        endpoint = "/api/branch/profile";
      }
      const response = await axiosInstance9000.get(endpoint);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const profileSlice = createSlice({
  name: "profileData",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default profileSlice.reducer;
